<a [routerLink]="['/seller-info']" [queryParams]="{ customerId: order().creatorCustomerId }"
  ><h6 i18n>Verkäufer: {{ order().creatorCustomerFullName }}</h6></a
>
@for (op of order().orderPositions; track op.id) {
  <app-order-group-order-position-item
    [orderPosition]="op"
    [claimable]="claimable()"
    [selected]="selection.has(op.id)"
    (selectedChange)="select(op.id, $event)"
  ></app-order-group-order-position-item>
}

@if (claimable() && hasBoughtPositions) {
  <button
    [asyncClick]="claim.bind(this)"
    [disabled]="claimBtn.disabled || selection.size === 0"
    #claimBtn="asyncClick"
    class="btn btn-secondary mt-4"
    type="button"
    data-testid="order-claim-button"
    i18n
    >
    @if (claimBtn.busy) { <span class="spinner-border spinner-border-sm me-1"></span> }
    Jetzt Stornierung anfordern
  </button>
}
